import { render, staticRenderFns } from "./ImportCSVBell.vue?vue&type=template&id=967f6e1e&scoped=true"
import script from "./ImportCSVBell.vue?vue&type=script&lang=js"
export * from "./ImportCSVBell.vue?vue&type=script&lang=js"
import style0 from "./ImportCSVBell.vue?vue&type=style&index=0&id=967f6e1e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "967f6e1e",
  null
  
)

export default component.exports